function zfill(digit, value) {
  value = String(value);
  let res = Array.from({ length: digit - value.length }, () => "0");
  res.push(value);
  return res.join("");
}
export default {
  priceFormat: (value) => {
    if (!value) return "0";
    let res = "";
    while (value >= 1000) {
      res = "," + zfill(3, value % 1000) + res;
      value = Math.floor(value / 1000);
    }
    return "" + value + res;
  },
};
